import { cloneObject } from '../../../../utils';
import { getFields } from '../../../../utils/defaultFields';

const fields = [
    'costCenterCode',
    'costCenterName',
    'costCenterInitials',
    'costCenterResponsible',
    'comercialPhone',
    'ramal',
    'cep',
    'address',
    'addressNumber',
    'complement',
    'hood',
    'uf',
    'city',
    'cellphone',
    'email',
];

const schema = cloneObject(getFields(fields));

schema.email.required = false;
schema.cellphone.required = false;

schema.uf.required = false;
schema.city.required = false;

export default schema;
